import React, { useState, useContext, useEffect } from 'react';
import { Modal, FormGroup, Label, Row, Col, Container } from 'reactstrap';
import moment from 'moment';

import { symbolPriceFormatter } from '~/helpers/price';
import { PedidoContext } from '~/context/PedidoContext';
import { ExtratoContext } from '~/context/ExtratoContext';

import ReactGA from 'react-ga4';
import { LoaderLista, LoaderMini } from '../../Loaders';
import ModalConfirmar from './confirm';

import {
	ModalFooterCss,
	DivCss,
	Th,
	Td,
	Title,
	TextoSaldo,
	ValoresSaldo,
	InputCss,
	ButtonCss,
	ModalBodyCss,
} from './styles';

export function ModalAprovar(props) {
	const { toggle, idPedido, numPedido, setToggle, user, setMeusPedidos, pagina, filtroStatus, filtroPesquisa, filtroData } = props;

	const { getPedidos, getPedidoIndividual, aprovarOuReprovarPedido } = useContext(PedidoContext);
	const { dataSaldo, loadingSaldo, getSaldo, getExtrato } = useContext(ExtratoContext);
	const [modalAprovar, setModalAprovar] = useState(false);
	const [modalReprovar, setModalReprovar] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (toggle) {
			getPedidoIndividual(idPedido.toString(), 'recebidos').then((res) => {
				setCampos(res.data.pedido);
				setLoading(false)
			});
			setLoading(true)
		}
	}, [toggle]);

	function toggleModalAprovar() {
		setModalAprovar(!modalAprovar);
	}

	function toggleModalReprovar() {
		setModalReprovar(!modalReprovar);
	}

	function handleClickAprovarCobrança() {
		ReactGA.event({
			category: "aprovar_cobranca",
			action: "Aprovar Pedido",
			label: "Aprovando Pedido",
		});
	}

	function handleClickNegarCobrança() {
		ReactGA.event({
			category: "negar_cobranca",
			action: "Negar Pedido",
			label: "Negando Pedido",
		});
	}

	const [campos, setCampos] = useState({
		id: '',
		nome: '',
		documento: '',
		data_pedido: '',
		contato: '',
		nota_fiscal: '',
		descricao: '',
		valor_pedido: 0,
		status: 1,
	});

	return (
		<>
			<Modal
				isOpen={toggle}
				size="xl"
				style={{ maxWidth: 990, width: '100%' }}>
				<Title>
					Verificação da cobrança do Pedido #
					{numPedido || <LoaderMini />}
				</Title>

				{!loading ?
					<>
						<ModalBodyCss>
							<Container xs="12" md="12" lg="12">
								<Row xs="12" md="12" lg="12">
									<Col xs="12" md="7" lg="7">
										<DivCss>
											<Th>Distribuidor:</Th>
											<Td>{campos.nome}</Td>
										</DivCss>

										<DivCss>
											<Th>CPF/CNPJ:</Th>
											<Td>{campos.documento}</Td>
										</DivCss>

										<DivCss>
											<Th>Ref. Pedido:</Th>
											<Td>
												{numPedido}
											</Td>
										</DivCss>
										{/* <DivCss>
									<Th>Sede:</Th>
									<Td>{campos.sede}</Td>
								</DivCss> */}
									</Col>

									<Col xs="12" md="5" lg="5">
										<DivCss>
											<Th>Data do Pedido:</Th>
											<Td style={{ textAlign: 'right' }}>
												{moment(campos.data_pedido).format(
													'DD/MM/YYYY'
												)}
											</Td>
										</DivCss>

										<DivCss>
											<Th>Contato comercial:</Th>
											<Td>{campos.contato}</Td>
										</DivCss>

										<DivCss>
											<Th>Nota Fiscal:</Th>
											<Td style={{ textAlign: 'right' }}>
												{/* {campos.nota_fiscal} */}
											</Td>
										</DivCss>

									</Col>
								</Row>

								<FormGroup>
									<Label>Descrição do pedido</Label>

									<InputCss
										type="textarea"
										name="descricao"
										value={campos.descricao}
										disabled
									/>
								</FormGroup>

								<Col xs="12" md="12" lg="12">
									{!loadingSaldo ?
										<>
											<Row style={{ justifyContent: 'end' }}>
												<TextoSaldo>Total Geral:</TextoSaldo>

												<ValoresSaldo style={{ color: '#FF1E58' }}>
													-
													{' '}
													{symbolPriceFormatter(campos.valor_pedido)}
												</ValoresSaldo>
											</Row>

											<Row style={{ justifyContent: 'end' }}>
												<TextoSaldo>Saldo/Credito Atual:</TextoSaldo>

												<ValoresSaldo
													style={{
														color: '#4A4A49',
														borderBottom: '1px solid black',
													}}>
													{' '}
													{symbolPriceFormatter(dataSaldo.saldo)}
												</ValoresSaldo>
											</Row>

											<Row style={{ justifyContent: 'end' }}>
												<TextoSaldo>Saldo/Credito Restante:</TextoSaldo>

												<ValoresSaldo style={{ color: campos.valor_pedido <= dataSaldo.saldo ? '#76B64D' : '#FF1E58' }}>
													{' '}
													{symbolPriceFormatter(dataSaldo.saldo - campos.valor_pedido)}
												</ValoresSaldo>
											</Row>
											{' '}
										</> : <LoaderMini />}
								</Col>
							</Container>
						</ModalBodyCss>

						<ModalFooterCss>
							<ButtonCss
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid #4A4A49',
								}}
								size="sm"
								onClick={() => { setToggle(false) }}>
								CANCELAR
							</ButtonCss>

							<ButtonCss
								onClick={() => {
									toggleModalReprovar()
									handleClickNegarCobrança()
								}}
								style={{
									backgroundColor: '#FF000040',
									color: '#FF1E58',
									border: '1px solid #FF1E58',
								}}
								size="sm">
								NÃO APROVAR
							</ButtonCss>
							<ButtonCss
								size="sm"
								disabled={campos.valor_pedido > dataSaldo.saldo}
								onClick={() => {
									toggleModalAprovar()
									handleClickAprovarCobrança()
								}}>
								APROVAR COBRANÇA
							</ButtonCss>
						</ModalFooterCss>
					</> : <LoaderLista />}
			</Modal>

			<ModalConfirmar
				aprovar
				toggleModalConfirm={() => {
					setToggle(false);
					aprovarOuReprovarPedido(numPedido.toString(), 'aprovar').then(() => getPedidos(10, pagina, 'recebidos', filtroData, filtroStatus, filtroPesquisa).then(res => {
						getExtrato(user.dados.documento, 1, filtroData, '', filtroPesquisa, '', '');
						getSaldo(user.dados.documento, '');
						setMeusPedidos(res.data.pedidos);
					}))
				}}
				toggle={() => toggleModalAprovar()}
				isOpen={modalAprovar}
			/>

			<ModalConfirmar
				toggleModalConfirm={() => {
					setToggle(false);
					aprovarOuReprovarPedido(numPedido.toString(), 'reprovar').then(() => getPedidos(10, pagina, 'recebidos', filtroData, filtroStatus, filtroPesquisa).then(res => {
						setMeusPedidos(res.data.pedidos);
					}))
				}}
				toggle={() => toggleModalReprovar()}
				isOpen={modalReprovar}
			/>
		</>
	);
}
